import { render, staticRenderFns } from "./filed.vue?vue&type=template&id=038983e2&scoped=true&"
import script from "./filed.vue?vue&type=script&lang=js&"
export * from "./filed.vue?vue&type=script&lang=js&"
import style0 from "./filed.vue?vue&type=style&index=0&id=038983e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038983e2",
  null
  
)

export default component.exports